module.exports = __webpack_public_path__ + "img/barajar.8ab3651b.svg";